import { KeyboardDoubleArrowUp } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React, { useState } from 'react';

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
      /* you can also use 'auto' behaviour 
		in place of 'smooth' */
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <Tooltip title="Kembali ke Atas">
      <IconButton
        onClick={scrollToTop}
        style={{
          display: visible ? 'inline' : 'none',
          position: 'fixed',
          right: '35px',
          bottom: '50px',
          fontSize: '3rem',
          zIndex: 1,
          cursor: 'pointer'
        }}
      >
        <KeyboardDoubleArrowUp />
      </IconButton>
    </Tooltip>
  );
};

export default ScrollButton;
